// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3XvU4","content":"styles_content__2gsvY","selectAll":"styles_selectAll__3XxmV"};